import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

export const useRouteChangeDispatch = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    return useEffect(() => {
        dispatch({ type: '@@router/LOCATION_CHANGE' });
    }, [dispatch, location.pathname]);
};
